import React from 'react';
import { Button, Card, CardBody, Input } from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";
import DataTable from 'react-data-table-component';
import styled from 'styled-components';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';

const TextField = styled.input`
        height: 32px;
        width: 200px;
        border-radius: 3px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border: 1px solid #e5e5e5;
        padding: 0 32px 0 16px;
        &:hover {
            cursor: pointer;
        }
    `;

    const ClearButton = styled.button`
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        height: 34px;
        width: 32px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    `;

    const FilterComponent = ({ filterText, onFilter, onClear }) => (
      <>
      <TextField
        id="search"
        type="text"
        placeholder="Filter By Phone"
        aria-label="Search Input"
        value={filterText}
        onChange={onFilter}
      />
      <ClearButton type="button" onClick={onClear}>
        X
      </ClearButton>
    </>
  );

function Partner() {
    let backEndUrl = localStorage.getItem("be");
    const { state } = useLocation();
    const navigate = useNavigate();
    const [customers, setCustomers] = React.useState([]);
    const [selectedCustomer, setSelectedCustomer] = React.useState({});
    const [show, setShow] = React.useState(false);
    const [showEditSittings, setShowEditSittings] = React.useState(false);
    let phoneNumber = React.createRef();
    let name = React.createRef();
    let sittings = React.createRef();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleEditShow = (show, data) => {
      name.current = {value: data.name};
      phoneNumber.current = {value: data.phone};
      setSelectedCustomer(data);
      setShowEditSittings(true)
    };

    async function getCustomers() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      // console.log(state);
  
      await fetch(backEndUrl + "api/customer/getusers/" + state.id, requestOptions)
        .then(response => response.text())
        .then(result => {
          let CustomerData = JSON.parse(result);
          // console.log(CustomerData);
          if(CustomerData.length > 0) {
            setCustomers(CustomerData);
          } else {
            alert("No Customers Available!")
          }
        })
        .catch(error => console.log('error', error));
    }

    React.useEffect(() => {
        getCustomers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const addCustomer = async () => {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", "Bearer " + state.token)
  
      let raw = JSON.stringify({
          "name": name.current.value,
          "massageLeft": 100,
          "type": "premium",
          "phone": phoneNumber.current.value
      });
  
      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
      };
  
      await fetch(backEndUrl + "api/customer", requestOptions)
        .then(response => response.text())
        .then(result => {
          let partnerData = JSON.parse(result);
          if(partnerData["message"]) {
            alert(partnerData["message"])
          } else {
            setCustomers(partners => [...partners, partnerData]);
            handleClose();
          }
        })
        .catch(error => console.log('error', error));
    }

    const editUserSittings = async () => {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", "Bearer " + state.token)
      console.log(state.token)
      let requestOptions = {
        method: 'PATCH',
        headers: myHeaders
      };
  
      await fetch(backEndUrl + "api/customer/sittings/" + selectedCustomer.phone + "/" + sittings.current.value, requestOptions)
        .then(response => response.text())
        .then(result => {
          let partnerData = JSON.parse(result);
          if(partnerData["message"]) {
            alert(partnerData["message"])
          } else {
            //setCustomers(partners => [...partners, partnerData]);
            alert("Sittings Updated Successfully. Please refresh the page to see updated Sittings.")
            setShowEditSittings(false);
          }
        })
        .catch(error => console.log('error', error));
    }

    let columns = [
        {
            name: 'Name',
            selector: row => row.name,
        },
        {
            name: 'Sittings Left',
            selector: row => row.sittings,
        },
        {
            name: 'Phone',
            selector: row => row.phone,
        },
        {
          name: 'Action',
          selector: row => <Button onClick={() => handleEditShow(true, row)}>Edit</Button>,
        }
    ];

    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const [filterText, setFilterText] = React.useState('');
    const filteredItems = customers.filter(
        item => item.phone && item.phone.includes(filterText),
    );

    const subHeaderComponentMemo = React.useMemo(() => {
		const handleClear = () => {
			if (filterText) {
				setResetPaginationToggle(!resetPaginationToggle);
				setFilterText('');
			}
		};

		return (
			<FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
		);
	}, [filterText, resetPaginationToggle]);

  function logout(){
    navigate("/");
  }

  return (
    <div className="App">
    <div style={{maxWidth: '40rem', margin: "0 auto"}}>
        <DataTable
            title="Customers"
            columns={columns}
            data={filteredItems}
            pagination
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
        />
    </div>
    
    <Card
        color="dark"
        >
        <CardBody>
          <Button color="light"  onClick={handleShow} style={{float: "center", marginRight: '20px'}}>Add Customer</Button>
          <Button color="light" onClick={logout}> Logout </Button>
        </CardBody>
      </Card>


      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Name</Form.Label>
              <Input innerRef={name} type="text" placeholder="Customer Name"/>
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Phone Number</Form.Label>
              <Input innerRef={phoneNumber} type="number" placeholder="Customer Phone Number"/>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={addCustomer}>
            Add Customer
          </Button>
        </Modal.Footer>
    </Modal>

    <Modal show={showEditSittings} onHide={() => setShowEditSittings(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Sittings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Sittings to be Added</Form.Label>
              <Input innerRef={sittings} type="number" placeholder="Sittings to be Added"/>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditSittings(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={editUserSittings}>
            Update Sittings
          </Button>
        </Modal.Footer>
    </Modal>
    </div>
);
}

export default Partner;